import { isEmpty, isNull } from 'lodash';
import config from 'commons-vehicle/config/index.js';
import { REDIRECTIONS } from '@sm360/widget-commons-general';
import { UrlService, LocaleService } from '@sm360/widget-commons-core-services';

export default function getCertificationIcon(make) {
    if (isEmpty(make) || isNull(make)) {
        return '';
    }
    const serverUrl = config.source.image;
    let certificationUrl = serverUrl + REDIRECTIONS[LocaleService.getSimpleLocale()].certified;
    certificationUrl = UrlService.replaceParamWithValue(certificationUrl, '{make}', make.toLowerCase());
    return certificationUrl;
}



// WEBPACK FOOTER //
// ./src/Vehicle/services/CertificationIconService/CertificationIconService.js